import React from 'react';
import {
  PublicDataset,
  useGetAvailablePublicDatasetsQuery,
} from '@/features/publicDatasets/publicDatasetApi';
import { useNavigate, useParams } from 'react-router-dom';
import { Dropdown, TrevorIcon } from '@trevor/ui-components';
import { UUID } from '@/types';
import {
  DatasourceList,
  PublicDatasourceDropdownWrapper,
  SelectedDatasource,
} from '@/features/publicDatasets/publicdatasets/PublicDatasetsDropdown/styled-components';
import { DatasourceItem } from '@/features/publicDatasets/publicdatasets/PublicDatasetsDropdown/subcomponents/PublicDatasetDropdownItem';

export const PublicDatasetsDropdown: React.FC<{ onSelect: F0 }> = ({
  onSelect,
}) => {
  const { data } = useGetAvailablePublicDatasetsQuery();
  const { datasourceId } = useParams();

  const navigate = useNavigate();

  const selected = data?.find((d) => d.id === (datasourceId as UUID));

  const selectDatasource = (datasouce: PublicDataset) => {
    if (selected?.id === datasouce.id) {
      return;
    }
    navigate(`/publicdatasets/${datasouce.id}`);
    onSelect();
  };

  return (
    <PublicDatasourceDropdownWrapper>
      <Dropdown>
        <Dropdown.Trigger>
          <SelectedDatasource>
            <span>{selected?.name}</span>

            <TrevorIcon name="dropdown-arrow-down" size={18} />
          </SelectedDatasource>
        </Dropdown.Trigger>
        <Dropdown.Content top={45} width="100%">
          <DatasourceList>
            {data?.map((c) => (
              <DatasourceItem
                key={c.id}
                selected={selected?.id === c.id}
                onSelect={() => selectDatasource(c)}
              >
                {c.name}
              </DatasourceItem>
            ))}
          </DatasourceList>
        </Dropdown.Content>
      </Dropdown>
    </PublicDatasourceDropdownWrapper>
  );
};
